import React, { useState, useContext, useEffect, useRef } from "react";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";
import { FaFilter } from "react-icons/fa";
import { IoClose  } from "react-icons/io5";
import { PeFilterContext } from '../Contexts/PeFilterContext';
import { useLocation } from "react-router-dom";
import { BsArrowRightSquareFill } from "react-icons/bs";
import '../styles/filterComponents.css';

export default function Sidebar({ children }) {
    const {dropdown, setDropdown, setOpen, open, isMobile, setIsMobile} = useContext(PeFilterContext);
    const location = useLocation(); 
    const hasNumberInURLRef = useRef(false);

    useEffect(() => {
        
        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);
        };
        
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [location.pathname, setIsMobile]);

    return (
        <div className="relative">
            {/* Filter Modal */}
            {open && (
                <div className="filter-modal">
                    <div className="filter-modal-content flex flex-col">
                        {/* Header */}
                        <div className="flex justify-between items-center flex-shrink-0">
                            <h2 className="text-lg font-semibold text-[#BC8B20] flex items-center">
                                <span className="font-bold text-[14px] md:text-[16px] ml-1">REFINE SEARCH</span>
                                {/* {dropdown ? (
                                    <IoMdArrowDropdown onClick={() => setDropdown(!dropdown)} className="cursor-pointer" />
                                ) : (
                                    <IoMdArrowDropright onClick={() => setDropdown(!dropdown)} className="cursor-pointer" />
                                )} */}
                            </h2>
                            <button type="button" onClick={() => setOpen(false)} className="text-gray-500 hover:text-gray-700">
                                <IoClose size={24} />
                            </button>
                        </div>

                        {/* Filters Grid Layout */}
                        <div className={`filter-grid flex-1 overflow-y-auto overflow-x-hidden ${dropdown ? '' : 'hidden'}`}>
                            {children}
                        </div>

                        {/* Action Buttons - Sticky at bottom */}
                        <div className="flex justify-end space-x-3 md:space-x-4 pt-3 mt-auto border-t border-gray-200 bg-white flex-shrink-0">
                            <button 
                                type="button"
                                onClick={() => {
                                    // This will trigger the reset in the form
                                    const form = document.querySelector('form');
                                    if (form) form.reset();
                                }}
                                className="px-3 md:px-4 py-2 text-sm md:text-base text-gray-600 border border-gray-300 rounded-md hover:bg-gray-50"
                            >
                                Reset
                            </button>
                            <button 
                                type="button"
                                onClick={() => {
                                    // This will trigger the submit in the form
                                    const form = document.querySelector('form');
                                    if (form) form.requestSubmit();
                                    setOpen(false);
                                }}
                                className="px-3 md:px-4 py-2 text-sm md:text-base bg-[#bc8b20] text-white rounded-md hover:bg-[#a67a1b]"
                            >
                                Filter
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
